/* eslint-disable import/no-cycle */
//import { observable } from 'mobx';
import UserStore from './stores/userStore';
import ReportStore from './stores/ReportStore';
import RouterStore from './stores/routerStore';
import CompanyStore from './stores/companyStore';
import MatchedStore from './stores/matchedStore';
import PageStore from './stores/pageStore';

// Default state structure
// Everything that defines our application and that could be
// shared between components should be declared here.

const defaultState = {
  app: {
    title: 'Insignary',
  },
  user: new UserStore(this),
  breadCrumbs: {},
  report: new ReportStore(this),
  routerState: new RouterStore(this),
  company: new CompanyStore(this),
  matched: new MatchedStore(this),
  pages: new PageStore(this),
};

export default defaultState;
